const box = "_35sbotpkzi";
const player = "_35sp15t56b0";

export { box, player };
import "./input.audio.style.linaria.module.css";
//# sourceMappingURL=input.audio.style.js.map
